import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Menu, X } from 'lucide-react';
import LanguageSwitcher from '../../i18n/LanguageSwitcher';
import './Navbar.css';

const navLinks = [
  { to: '/', key: 'home', end: true },
  { to: '/training', key: 'cybersecurity' },
  { to: '/ai-training', key: 'aiTraining' },
  { to: '/prompt-crafter', key: 'promptCrafter' },
];

function Navbar() {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar" role="navigation">
      <div className="navbar-inner">
        <NavLink to="/" className="navbar-brand" onClick={() => setMenuOpen(false)}>
          Markataos
        </NavLink>

        {/* Desktop nav */}
        <ul className="navbar-links">
          {navLinks.map(({ to, key, end }) => (
            <li key={key}>
              <NavLink
                to={to}
                end={end}
                className={({ isActive }) => `navbar-link${isActive ? ' navbar-link--active' : ''}`}
              >
                {t(`nav.${key}`)}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="navbar-actions">
          <LanguageSwitcher className="navbar-lang-switcher" />
          <button
            className="navbar-hamburger"
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label={menuOpen ? t('nav.closeMenu') : t('nav.openMenu')}
          >
            {menuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`navbar-mobile${menuOpen ? ' navbar-mobile--open' : ''}`}>
        <ul className="navbar-mobile-links">
          {navLinks.map(({ to, key, end }) => (
            <li key={key}>
              <NavLink
                to={to}
                end={end}
                className={({ isActive }) => `navbar-mobile-link${isActive ? ' navbar-mobile-link--active' : ''}`}
                onClick={() => setMenuOpen(false)}
              >
                {t(`nav.${key}`)}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
